// extracted by mini-css-extract-plugin
export default {"container":"_U-z","modal":"aV-z","dimensions":"bV-z","brandName":"cV-z","productName":"dV-z","recipientEmail":"eV-z","recommendedFit":"fV-z","hiddenField":"gV-z"};